import React from "react";
import Dialog from "@material-ui/core/Dialog";
import Slide from "@material-ui/core/Slide";
import { TransitionProps } from "@material-ui/core/transitions";
import PrimaryTheme from "../Themes/Primary";
import { useSelector, useDispatch } from "react-redux";
import { Reducers } from "../Interfaces/Interfaces";
import Input from "./Input";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function StatusAlert(props: DialogProps) {
  const statusAlert = useSelector((state: Reducers) => state.statusAlert);
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch({
      type: "STATUS_ALERT",
      payload: false,
    });
  };

  return (
    <div
      className="position-relative"
      style={{
        borderRadius: "20px !important",
      }}
    >
      <Dialog
        open={statusAlert}
        TransitionComponent={Transition}
        keepMounted
        scroll="body"
        fullWidth
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <div className="position-relative">
          {props.showClose && (
            <React.Fragment>
              <div className="p-4"></div>

              <div
                onClick={handleClose}
                style={{
                  width: 50,
                  height: 50,
                  position: "absolute",
                  top: 0,
                  right: 0,
                  backgroundColor: PrimaryTheme.warn,
                  color: PrimaryTheme.black,
                  fontSize: PrimaryTheme.fontSizes?.subtitle,
                  borderBottomLeftRadius: 10,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                }}
              >
                <svg
                  width="1em"
                  height="1em"
                  viewBox="0 0 16 16"
                  className="bi bi-x"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M11.854 4.146a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708-.708l7-7a.5.5 0 0 1 .708 0z"
                  />
                  <path
                    fillRule="evenodd"
                    d="M4.146 4.146a.5.5 0 0 0 0 .708l7 7a.5.5 0 0 0 .708-.708l-7-7a.5.5 0 0 0-.708 0z"
                  />
                </svg>
              </div>
            </React.Fragment>
          )}

          <div className="col-md-12 p-5 text-center">
            <div className="col-md-12">
              {/* <img src="/favicon.ico" alt="Logo"/> */}
              <img
                src="/gif/check.gif"
                style={{
                  width: "90px",
                }}
              />
            </div>

            <div className="col-md-12">
              <span
                className="badge-pill p-3 d-block col-md-12 ml-auto mr-auto"
                style={{
                  color: PrimaryTheme.success,
                  fontFamily: PrimaryTheme.fonts?.MediumFont,
                }}
              >
                {props.title}
              </span>
            </div>

            <p
              className=" mb-5"
              style={{
                fontFamily: PrimaryTheme.fonts?.RegularFont,
                fontSize: 12,
                color: PrimaryTheme.light,
              }}
            >
              {props.subtitle}
            </p>

            <div className="form-group mt-5 mb-0">
              <Input
                onClick={props.onClick}
                type="button"
                isInput
                value={props.buttonTitle}
                style={{
                  background: PrimaryTheme.warn,
                  fontFamily: PrimaryTheme.fonts?.MediumFont,
                  color: PrimaryTheme.dark,
                }}
                className="text-bold border-0 col-md-6"
              />
              <button className="btn btn-light" onClick={props.goBack}>
                {props.backTitle}
              </button>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
}

interface DialogProps {
  children?: React.ReactElement;
  open?: boolean;
  showClose?: boolean;
  title: string;
  subtitle?: string;
  buttonTitle?: string;
  backTitle?: string;
  goBack?: any;
  onClick?: any;
}
